import { createSvgIcon } from '@mui/material';

export const AccountDetails = createSvgIcon(
  <path
    fill="currentColor"
    d="M11 9C11 10.66 9.66 12 8 12C6.34 12 5 10.66 5 9C5 7.34 6.34 6 8 6C9.66 6 11 7.34 11 9M14 20H2V18C2 15.79 4.69 14 8 14C11.31 14 14 15.79 14 18M22 12V14H13V12M22 8V10H13V8M22 4V6H13V4Z"
  />,
  'AccountDetails',
);
